<template>
  <Dialog :class="['Dialog--withLogo', modifierClass]" v-on="$listeners" v-bind="$props">
    <div class="Dialog__logo"><img src="./img/logo.png" alt=""></div>
    <slot></slot>
  </Dialog>
</template>

<script>
import Dialog from "../Dialog";

export default {
  name: "DialogWithLogo",
  components: {
    Dialog,
  },
  props: {
    ...Dialog.props,
    modifierClass: {},
  },
};
</script>

<style lang="scss">
$page-width: 375;
@import "~style/tool";

.Dialog--withLogo {
  .Dialog__logo {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(233, 90, 89, 1);
    height: 62px;
    border-radius: 4px 4px 0 0;

    img {
      display: block;
      margin: 16px auto 0;
      width: 213;
      height: 28px;
    }
  }

  .Dialog__body {
    padding-top: 80px;
  }
}
</style>
